// :cow: Cosmose CONFIDENTIAL :iso:
import { ProfileDto } from '../model/profile.model';

export interface AuthState {
  profile?: ProfileDto;
}

export const initialState: AuthState = {
  profile: undefined,
};
